/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminCreate } from '../models/AdminCreate';
import type { AdminDetails } from '../models/AdminDetails';
import type { AdminUpdate } from '../models/AdminUpdate';
import { request as __request } from '../core/request';

export class ReaderVService {

    /**
     * @param operatorId
     * @param userRoleId
     * @param name
     * @param email
     * @param isActive
     * @param fromCreatedAt
     * @param toCreatedAt
     * @param createdBy
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async readerVGetAll(
        operatorId: string,
        userRoleId?: number,
        name?: string,
        email?: string,
        isActive?: boolean,
        fromCreatedAt?: string,
        toCreatedAt?: string,
        createdBy?: string,
    ): Promise<Array<AdminDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/meter_readers`,
            query: {
                'OperatorId': operatorId,
                'UserRoleId': userRoleId,
                'Name': name,
                'Email': email,
                'IsActive': isActive,
                'FromCreatedAt': fromCreatedAt,
                'ToCreatedAt': toCreatedAt,
                'CreatedBy': createdBy,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AdminDetails Created
     * @throws ApiError
     */
    public static async readerVCreate(
        requestBody?: AdminCreate,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/meter_readers`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param meterReaderId
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async readerVGetById(
        meterReaderId: string,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/meter_readers/${meterReaderId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param meterReaderId
     * @param requestBody
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async readerVUpdate(
        meterReaderId: string,
        requestBody?: AdminUpdate,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'PUT',
            path: `/api/v2/meter_readers/${meterReaderId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param meterReaderId
     * @returns any OK
     * @throws ApiError
     */
    public static async readerVDelete(
        meterReaderId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/meter_readers/${meterReaderId}`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}